import React from "react";

export default () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 11.675a2.688 2.688 0 0 1-2.679-2.696c0-1.489 1.2-2.697 2.679-2.697a2.688 2.688 0 0 1 2.679 2.697c0 1.488-1.2 2.696-2.679 2.696m0-10.246c-4.147 0-7.5 3.375-7.5 7.55C5 14.64 12.5 23 12.5 23S20 14.64 20 8.979c0-4.175-3.353-7.55-7.5-7.55"
      stroke="#4A4A4A"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);
